// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  authentication: {
    apiKey: '21111f5d58b791fa2b5b9ce8601ceaa617fb26e7c81214e0ea404bcabbc2d316'
  },
  // shippingApiBaseUrl: 'https://staging-shipping-api.cufi.org/v1',
  // ecommerceApiBaseUrl: 'https://staging-ecommerce-api.cufi.org/v1',

  shippingApiBaseUrl: 'https://shipping-api.cufi.org/v1',
  ecommerceApiBaseUrl: 'https://ecommerce-api.cufi.org/v1',


  // shippingApiBaseUrl: 'http://localhost:5697/v1',
  // ecommerceApiBaseUrl: 'http://localhost:7000/v1'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts